<template>
<div>
  <div>
    {{ $vuetify.t('$vuetify.cart.discount') }}
    <span class="red--text">{{getBill.discountAmount | currency | comma}}</span>
  </div>

  <template v-for="(coupon, couponIndex) in getAllBillCoupons">
    <div v-if="(!serverCoupons.length || !serverCoupons[0].orderItem) || (serverCoupons[0].code != coupon.code)"
      :key="`coupon_${couponIndex}`"
      :class="{ 'red--text': !_isCouponValid(coupon) }"
    >
      <v-icon @click="onRemoveCoupon()" small style="">
        cancel
      </v-icon>

      {{ coupon.code }}

      <v-tooltip bottom v-if="coupon.description" max-width="300px">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" small style="cursor: default">
            info
          </v-icon>
        </template>

        {{ coupon.description }}
      </v-tooltip>

      <template v-for="(rule, ruleIndex) in getInvalidRules(coupon)">
        <div :key="`rule_${couponIndex}_${ruleIndex}`" class="pl-2 caption">
          - {{ rule.description }}
        </div>
      </template>
    </div>
  </template>
</div>
</template>

<script>
import get from 'lodash/get';

import { mapActions, mapGetters } from 'vuex';

import { extractInvalidRulesFromCoupon, isCouponValid } from "@/services/util.service"

export default {
  computed: {
    serverCoupons() {
      return get(this.getServerCart, 'subOrderList[0].coupons', [])
    },

    ...mapGetters([
      'getServerCart',
      'getAllBillCoupons',
      'getBill'
    ])
  },

  methods: {
    _isCouponValid: val => isCouponValid(val),
    getInvalidRules: (coupon) => extractInvalidRulesFromCoupon(coupon),

    onRemoveCoupon() {
      this.removeCoupon()

      this.fetchShoppingCart()
      this.fetchBillView()
    },

    ...mapActions([
      'removeCoupon',
      'fetchShoppingCart',
      'fetchBillView'
     ])
  }
}
</script>

<style scoped>
  i, .v-icon, .v-icon--link .material-icons, .theme--light, {
    position: relative;
    top: -5px;
  }
</style>
